export class IVocab {
 id: string;
 label: string;
 code: string;
 lspFormType: string;
 vocabType: string;
}
